import type { PlateElementProps } from "platejs/react";
import { PlateElement } from "platejs/react";
import { cn } from "@/lib/utils";

export function TableElement({ children, className, ...props }: PlateElementProps) {
	return (
		<PlateElement {...props} as="div" className={cn("my-4", className)}>
			<div className="w-full overflow-x-auto">
				<table className="w-full border-collapse border">{children}</table>
			</div>
		</PlateElement>
	);
}

export function TableRowElement({ children, className, ...props }: PlateElementProps) {
	return (
		<PlateElement {...props} as="tr" className={cn("border-b", className)}>
			{children}
		</PlateElement>
	);
}

export function TableCellElement({ children, className, ...props }: PlateElementProps) {
	return (
		<PlateElement
			{...props}
			as="td"
			className={cn("min-w-[60px] border px-3 py-2 text-left align-top", className)}
		>
			{children}
		</PlateElement>
	);
}

export function TableCellHeaderElement({ children, className, ...props }: PlateElementProps) {
	return (
		<PlateElement
			{...props}
			as="th"
			className={cn(
				"min-w-[60px] border bg-muted px-3 py-2 text-left align-top font-bold",
				className,
			)}
		>
			{children}
		</PlateElement>
	);
}
